import React from "react";
import { Box } from "@mui/material";
import styles from "./CommonModalHeader.module.css";

const CommonModalHeader = ({ activeStep, locationStep, title, headerSx }) => {
  const isLocationStep = activeStep === locationStep;

  return (
    <Box
      sx={headerSx}
      className={`${styles.header} ${
        isLocationStep ? styles.locationStep : styles.defaultStep
      }`}
    >
      <h1 className={styles.title}>{title}</h1>
    </Box>
  );
};

export default CommonModalHeader;
